import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import s from '../../s.module.less';
import c from './s.module.less';

type Props = {
    // solo = Individual NPI / group = Practice NPI，决定卡片内容与弹窗文案
    variant: 'solo' | 'group';
    // 点击弹窗主按钮后的动作（回到 billing type 选择页），由调用方决定是重置状态还是跳转
    onChangeBillingType: () => void;
    // group 专用：同一 practice 里除当前用户外的 provider 数，弹窗末句动态生成（0 则省略）
    otherProvidersCount?: number;
};

const COPY = {
    solo: {
        type: 'Individual NPI',
        billedUnder: 'Personal NPI (Type 1) and SSN or individual Tax ID',
        note: 'Your claims are billed under your personal NPI and SSN (or individual Tax ID), with no practice entity.',
        modalCurrent:
            'You are billing under your individual NPI right now. We will take you back to that choice, and picking ' +
            'the same option changes nothing.',
        modalSwitch:
            'If you switch: Everything you have entered about yourself carries over, and you become the first ' +
            'provider on the practice. The only thing left to add is your practice details: legal business name, ' +
            'group NPI (Type 2), EIN and location.',
    },
    group: {
        type: 'Practice NPI',
        billedUnder: 'Practice group NPI (Type 2) and EIN',
        note:
            "Your claims are billed under your practice's group NPI and EIN, not your personal SSN. You can add " +
            'providers to the practice anytime.',
        modalCurrent:
            'You are billing under your practice NPI right now. We will take you back to that choice, and picking ' +
            'the same option changes nothing.',
        modalSwitch:
            'If you switch: Everything you have entered about yourself carries over, including your licenses, ' +
            'malpractice, background, references and tax details. Your practice details (legal business name, ' +
            'group NPI, EIN, location) stop applying, because there is no practice entity on this option.',
    },
};

// Review 页顶部的 Billing type 卡片（solo/group review 共用）：只读展示当前计费类型，
// Edit 弹确认弹窗，确认后回到 billing type 选择页重新选择
export default function BillingTypePanel({ variant, onChangeBillingType, otherProvidersCount = 0 }: Props) {
    const [modalOpen, setModalOpen] = useState(false);
    const copy = COPY[variant];
    // group 切走会把同 practice 的其它 provider 移出本次申请，句子随人数动态生成
    const removalNote =
        variant === 'group' && otherProvidersCount > 0
            ? ` The other ${otherProvidersCount} provider${otherProvidersCount > 1 ? 's' : ''} in your practice would` +
              ' be removed from this application.'
            : '';

    return (
        <div className={s.reviewSection}>
            <div className={s.reviewSectionHeader}>
                <div className={s.reviewSectionTitle}>Billing type</div>
                <button type="button" className={s.reviewEditBtn} onClick={() => setModalOpen(true)}>
                    Edit
                </button>
            </div>
            <div className={s.reviewRow}>
                <div className={s.reviewItem}>
                    <div className={s.reviewItemLabel}>Billing type</div>
                    <div className={s.reviewItemValue}>{copy.type}</div>
                </div>
                <div className={s.reviewItem}>
                    <div className={s.reviewItemLabel}>Claims billed under</div>
                    <div className={s.reviewItemValue}>{copy.billedUnder}</div>
                </div>
            </div>
            <div className={c.note}>{copy.note}</div>

            <Modal
                open={modalOpen}
                title="Change your billing type?"
                onCancel={() => setModalOpen(false)}
                footer={
                    <>
                        <Button onClick={() => setModalOpen(false)}>Cancel</Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                setModalOpen(false);
                                onChangeBillingType();
                            }}
                        >
                            Change billing type
                        </Button>
                    </>
                }
            >
                <p className={c.modalPara}>{copy.modalCurrent}</p>
                <p className={c.modalPara}>
                    {copy.modalSwitch}
                    {removalNote}
                </p>
            </Modal>
        </div>
    );
}
